import {
  compose,
  mapProps,
  setPropTypes,
  withState,
  withHandlers,
} from "recompose";
import PropTypes from "prop-types";
import makeQueryFromLocation from "./makeQueryFromLocation";

const EnhanceLayer = () =>
  compose(
    setPropTypes({
      location: PropTypes.shape({
        search: PropTypes.string,
        pathname: PropTypes.string.isRequired,
      }),
    }),
    withState("activeFilters", "setFilters", false),
    withHandlers({
      toggleFilters: (props) => () => props.setFilters(!props.activeFilters),
    }),
    mapProps(({ facetsParams, feature, ...props }) => {
      const query = makeQueryFromLocation(props.location, facetsParams);

      return {
        ...props,
        hasFilters: query.hasFilter(),
        page: query.getCurrentPage(),
        length: query.getSize(),
        variables: query.getFacetsParams(),
        sort: query.getSort(),
      };
    })
  );

export default EnhanceLayer;
